import './CtaCard.scss';

interface CtaCardProps {
  href: string;
  mascot: string;
  title: string;
  label: string;
}

export function CtaCard({ href, mascot, title, label }: CtaCardProps) {
  return (
    <a href={href} className="cta-card">
      <img src={mascot} alt="" className="cta-card__mascot" width={67} height={107} />
      <div className="cta-card__text">
        <span className="cta-card__title">
          <span className="cta-card__title-prefix">Les </span>
          {title}
        </span>
        <span className="cta-card__label">{label}</span>
      </div>
    </a>
  );
}

export default CtaCard;
